import React, { useState } from "react";
import { Box, Typography, Button, Divider, Paper } from "@mui/material";
import PlanModal from "./PlanModal";
import { useGetSubscriptionsQuery } from "slices/beautyApp/subscriptionSlice";
import { useAssisgnPlanMutation } from "slices/beautyApp/beauticianSlice";
import Swal from "sweetalert2";

export default function BookingsTab({ beautician, refetch }) {
  const [openModal, setOpenModal] = useState(false);
  const [showCurrentPlan, setShowCurrentPlan] = useState(false);
  const [assignPlan] = useAssisgnPlanMutation();
  const { data: subscriptionPlans, isLoading } = useGetSubscriptionsQuery({});
  const subscription = beautician?.subscription;
  const plan = subscription?.subscriptionPlan;

  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);
  const handleSelectPlan = async (plan) => {
    let body = {
      userId: beautician?.user?._id,
      planId: plan._id,
      cityId: beautician?.user?.appliedCity,
    };

    await assignPlan(body)
      .unwrap()
      .then(() => {
        Swal.fire("Success", "Plan assigned successfully", "success");
        refetch(); // refresh subscription data
        handleClose();
      })
      .catch((error) => {
        Swal.fire(
          "Error",
          error?.data?.message || "Something went wrong",
          "error",
        );
      });
  };

  return (
    <Box p={3} maxWidth={600} mx="auto">
      {/* Buttons with spacing */}
      <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap" }}>
        {subscription && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => setShowCurrentPlan((prev) => !prev)}
            sx={{ minWidth: 160 }}
          >
            {showCurrentPlan ? "Hide Current Plan" : "View Current Plan"}
          </Button>
        )}

        <Button
          variant="contained"
          color="secondary"
          onClick={handleOpen}
          disabled={isLoading}
          // sx={{ minWidth: 160 }}
          sx={{
            minWidth: 160,
            // mt: 2,
            color: "black !important ",
            border: "1px solid black",
          }}
        >
          {subscription ? "Change Plan" : "Choose Plan"}
        </Button>
      </Box>

      {/* Current Subscription View */}
      {showCurrentPlan && subscription && (
        <Paper variant="outlined" sx={{ p: 3, mb: 4, borderRadius: 2 }}>
          <Typography variant="h5" mb={2} fontWeight={700}>
            Current Subscription
          </Typography>

          <Divider sx={{ mb: 2 }} />

          <Typography mb={1}>
            <strong>Plan Name:</strong> {plan?.name}
          </Typography>

          <Typography mb={1}>
            <strong>Price:</strong> {subscription.price} {subscription.currency}
          </Typography>

          <Typography mb={1}>
            <strong>Duration:</strong> {subscription.durationInDays} days
          </Typography>

          <Typography mb={1}>
            <strong>Use Limit:</strong> {subscription.useLimit}
          </Typography>

          <Typography mb={1}>
            <strong>Remaining Days:</strong> {subscription.remainingDays}
          </Typography>

          <Typography mb={1}>
            <strong>City:</strong> {subscription.city?.cityName}
          </Typography>

          <Typography mb={1}>
            <strong>Status:</strong>{" "}
            <Box
              component="span"
              sx={{
                color:
                  subscription.status === "active"
                    ? "green"
                    : subscription.status === "expired"
                    ? "red"
                    : "gray",
                fontWeight: "bold",
                textTransform: "capitalize",
              }}
            >
              {subscription.status}
            </Box>
          </Typography>

          <Typography mb={1}>
            <strong>Start Date:</strong>{" "}
            {new Date(subscription.startDate).toLocaleDateString()}
          </Typography>

          <Typography mb={1}>
            <strong>End Date:</strong>{" "}
            {new Date(subscription.endDate).toLocaleDateString()}
          </Typography>
        </Paper>
      )}

      {/* If no subscription and user hides current plan */}
      {!subscription && !showCurrentPlan && (
        <Typography variant="body1" mb={3}>
          No subscription assigned
        </Typography>
      )}

      {/* Plan Modal (UNCHANGED FUNCTIONALITY) */}
      <PlanModal
        open={openModal}
        onClose={handleClose}
        plans={subscriptionPlans}
        onSelectPlan={handleSelectPlan}
      />
    </Box>
  );
}
